<template>
  <!-- prettier-ignore -->
  <div :class="classes">
    <div class="file-item__content">
      <ovp-icon
        art="light"
        name="paperclip"
      />
      <span
        class="file-item__name"
        @click="open"
        v-text="file.name"
      />
      <div>
        <ovp-icon
          v-if="removable"
          art="light"
          name="trash"
          @click="remove"
        />
      </div>
    </div>

    <div class="file-item__progress">
      <progress
        max="100"
        :value="progress"/>
    </div>

    <div
      v-if="hasError"
      class="file-item__message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { STATUS, ERRORS } from '@/helpers/FileHandler'

export default {
  name: 'FileItem',

  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  emits: ['open', 'remove'],

  data() {
    return {
      triggered: false,
    }
  },

  computed: {
    removable() {
      return (this.valid || this.hasError) && !this.triggered
    },

    valid() {
      return this.file.status === STATUS.READY
    },

    hasError() {
      return this.file.status === STATUS.ERROR
    },

    errorMessage() {
      const { error } = this.file
      return error === ERRORS.NETWORK_ERROR ? this.$t('error.NETWORK') : this.$t(`error.${error}`)
    },

    progress() {
      const { file, valid } = this
      return valid ? 100 : file.percentage
    },

    classes() {
      const { status } = this.file
      return {
        'file-item': true,
        'file-item--success': this.valid,
        'file-item--failure': this.hasError,
        'file-item--is-waiting': status === STATUS.WAITING,
        'file-item--is-uploading': status === STATUS.PROCESSING,
      }
    },
  },

  methods: {
    open() {
      if (this.valid) {
        this.$emit('open', this.file)
      }
    },

    remove() {
      if (this.removable) {
        this.triggered = true
        this.$emit('remove', this.file)
      }
    },
  },
}
</script>

<style scoped lang="postcss">
.file-item {
  margin-bottom: 10px;

  &__content {
    display: flex;
    align-items: center;

    :first-child {
      margin-right: 10px;
    }

    :last-child {
      margin-right: 0;
      margin-left: auto;

      .icon {
        cursor: pointer;
      }
    }
  }

  &__name {
    width: 100%;
    max-width: calc(100% - 50px);
    margin: auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__message {
    margin-left: 28px;
  }

  &--failure {
    color: var(--c-error);
  }

  &--success {
    cursor: pointer;

    .file-item {
      &__name {
        font-weight: bold;
        color: var(--c-original-green);

        &:hover {
          color: var(--c-hover-original-green);
        }
      }
    }
  }
}
</style>

<style scoped lang="postcss">
.file-item {
  &__progress {
    line-height: 2px;
    margin-bottom: 5px;

    progress {
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;

      width: 100%;
      height: 2px;
      color: var(--c-sanitas-green);
      background-color: var(--c-sanitas-green);
    }
  }

  &--failure {
    progress,
    progress::-webkit-progress-value {
      color: var(--c-error);
      background-color: var(--c-error);
    }
  }
}
</style>
